import React, { useEffect, useState, useCallback } from 'react';
import {Col,FormControl} from 'react-bootstrap';
import axios from 'axios';
import {useSelector} from 'react-redux';
import {service,servicehistory} from '../../../../url';
import ServiceInfo from './ServiceInfo';
import './HealthCheckServices.scss';

const HealthCheckServices = (props:any) => {
    const [servicesList, setServicesList] = useState<any>();
    const [originalServices, setOriginalServices] = useState<any>();
    const [excelResponse,setExcelResponse] = useState<any>([]);
    const [loader,setLoader] = useState(true)
    const [showExcel,setShowExcel] = useState(false);
    const jwtIdToken = useSelector((state:any) => state.user.token)

    const getServicesList = async () => {
        try {
            const url = `${service}?region=${props.region}`
            const response = await axios.get(url,{
                headers: {
                    'Authorization': jwtIdToken
                }
            });
            if(response.status === 200) {
                let data = response.data;
                setServicesList(data);
                setOriginalServices({...data});
                setLoader(false)
            }
            else {
                console.log('Server Issue');
                setLoader(false)
            }
        }
        catch(e) {
            console.log('error',e);
            setLoader(false)
        }
    }

    useEffect(() => {
        getServicesList();
        const interval = setInterval(() => {
            getServicesList();
        },30000);

        return () => {
            clearInterval(interval);
        }
    },[]);

    const toggleAccordion = useCallback((index:any) => {
        setShowExcel(false)
        let servicesDataList = {...servicesList};
      
        servicesDataList.serviceInfo[index].collapse = !servicesDataList.serviceInfo[index].collapse;
      
        setServicesList(servicesDataList);
    },[servicesList])

    const refreshServices = () => {
        getServicesList()
    }
    
    const onSearchClick = (e:any) => {
        let value = e.target.value;
         if(value.length) {

             const filteredItem = servicesList.serviceInfo.filter((item: any) => {
                 if (item.serviceId) {
                     return item.name.toLowerCase().includes(value.toLowerCase()) || item.app.toLowerCase().includes(value.toLowerCase()) || item.timestamp.toLowerCase().includes(value.toLowerCase())
                 }
                 return false
             });
             let lists = { ...servicesList };
             lists.serviceInfo = [...filteredItem]
             setServicesList(JSON.parse(JSON.stringify(lists)));
                    
        }
         else {
             setServicesList({...originalServices});
        }
    }

    const excelData = async (name:any,region:any) => {
        try {
            let regionArea = region.toLowerCase();
            let excelResponse = await axios.get(`${servicehistory}?name=${name}&&region=${regionArea}`,{
                headers: {
                    'Authorization': jwtIdToken
                }
            });
            setExcelResponse(excelResponse.data);
            setShowExcel(true);
        } catch (error) {
            console.log(error)
        }
    }

    return <Col xs={12} md={12} lg={6} key={props.index}>
        {
            loader ? <div className='mb-2 ms-3 ms-lg-0 loader'>loading...</div> :
                Object.keys(servicesList).length ?
                        <div className='serviceListBlock'>
                            <div className='clearfix'>
                                <div className='float-start'>
                                    <span className='blockTitle'>{servicesList.region}</span>
                                </div>
                                <div className='float-end'>
                                    <div className='controlsContainer'>
                                        <div className='me-2 searchbar'>
                                            <FormControl
                                                aria-label="ServiceSearch"
                                                aria-describedby="serviceSearchText"
                                                className='searchTextbox'
                                                size='sm'
                                                onKeyDown={(e: any) => { onSearchClick(e) }}
                                            />
                                            <button type='button' className='btn searchIcon'><span className='fa fa-search'></span></button>
                                        </div>
                                        <div className='controls' onClick={refreshServices}><span className='fa fa-refresh' /></div>
                                    </div>
                                </div>
                            </div>
                            <div className='serviceTable'>
                                <div className='serviceTableHeader'>
                                    <div className='accordionArrow'></div>
                                    <div title='App'>App</div>
                                    <div className='service' title='Service'>Service</div>
                                    <div title='Timestamp'>Timestamp</div>
                                    <div className='health' title='Health'>Health</div>
                                    <div className='route53' title='Route 53'>Route 53</div>
                                </div>
                                <div className='serviceTableBody'>
                                    {

                                        servicesList.serviceInfo ?
                                        servicesList.serviceInfo.map((item: any, index: any) => {
                                            return <ServiceInfo item={item} index={index} key={index}
                                                toggleAccordion={toggleAccordion} excelData={excelData}
                                                excelResponse={excelResponse} showExcel={showExcel} region={servicesList.region}
                                            />
                                            })
                                            : <div>No Data Available</div>
                                    }
                                </div>
                            </div>
                        </div>
                    : <div>No Data Available</div>
        }
    </Col>
}



export default HealthCheckServices;